import {Button, Form, Input, Modal} from 'antd';
import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {usePasswordChangeForm} from './usePasswordChangeForm';
import Loading from '@app/components/Loading/Loading';
import {
  useFormValidationRules,
  useInputMaxLength,
} from '@app/utils/formValidationRules';
import {useGetMeQuery} from '@app/redux/services/userService';

interface IPasswordChangeModalProps {
  open: boolean;
  onCancel: () => void;
}

const PasswordChangeModal: FC<IPasswordChangeModalProps> = ({
  open,
  onCancel,
}) => {
  const {t} = useTranslation();
  const {data: user} = useGetMeQuery();
  const {form, isLoading, onUpdate} = usePasswordChangeForm({
    user,
    onCancel,
  });
  const {emailRules, passwordRules, passwordConfirmationRules, requiredOnly} =
    useFormValidationRules();
  const inputMaxLength = useInputMaxLength();

  const onFinish = async () => {
    await onUpdate();
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={t('Own Password Edit')}
      footer={null}
    >
      {isLoading && <Loading />}
      <Form
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        labelCol={{span: 10, offset: 1}}
        wrapperCol={{span: 12}}
        labelAlign="left"
      >
        <Form.Item name="email" label={t('Email address')} rules={emailRules()}>
          <Input maxLength={inputMaxLength.email} disabled />
        </Form.Item>
        <Form.Item
          name="old_password"
          label={t('Current Password')}
          rules={requiredOnly()}
        >
          <Input.Password
            maxLength={inputMaxLength.password}
            placeholder={t('Placeholders.Password')}
          />
        </Form.Item>
        <Form.Item
          name="password"
          label={t('New Password')}
          rules={passwordRules()}
        >
          <Input.Password
            maxLength={inputMaxLength.email}
            placeholder={t('Placeholders.Password')}
          />
        </Form.Item>
        <Form.Item
          name="password_confirmation"
          label={t('New Password Confirmation')}
          messageVariables={{labelMatch: t('New Password')}}
          rules={passwordConfirmationRules({
            isRequired: true,
          })}
        >
          <Input.Password
            maxLength={inputMaxLength.email}
            placeholder={t('Placeholders.Password')}
          />
        </Form.Item>
        <div style={{textAlign: 'center', marginTop: '16px'}}>
          <Button type="primary" htmlType="submit">
            {t('Edit')}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default PasswordChangeModal;
